<template>
  <top-view>
    <v-card id="cardView">
      <v-row>
        <p class="profileHeader">{{ $t("profile_my_profile") }}</p>
        <v-divider class="divider"></v-divider>
      </v-row>
      <v-layout row>
        <v-flex xs12 sm6>
          <div class="container avatarPos">
            <v-avatar width="130px" height="130px">
              <v-img v-bind:src="imageUrl" />
            </v-avatar>
            <div class="bottom-right">
              <img src="@/assets/change_image.svg" v-on:click="onSelectAvatarClick" />
            </div>
            <input
              ref="uploader"
              class="d-none"
              type="file"
              accept="image/*"
              @change="onFileChanged"
            />
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="text-center">
            <v-row>
              <p class="headerText">
                {{ $t("profile_full_name") }}
                <i class="mdi mdi-information importantIcon"></i>
              </p>
            </v-row>
            <v-text-field
              class="textField"
              single-line
              append-icon="mdi-pencil"
              v-model="myProfile.name"
              :rules="notEmptyRule"
              required
              outline
              maxlength="30"
            ></v-text-field>
            <v-row>
              <p class="headerText">
                {{ $t("profile_birthday") }}
                <i class="mdi mdi-information importantIcon"></i>
              </p>
            </v-row>
            <v-menu v-model="birthDateMenu">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="birthDate"
                  readonly
                  class="textField"
                  append-icon="mdi-pencil"
                  single-line
                  required
                  outline
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="birthDate"
                :min="minDate"
                :max="maxDate"
                @input="birthDateMenu = false"
              ></v-date-picker>
            </v-menu>

            <v-row>
              <p class="headerText">
                {{ $t("profile_telephone") }}
                <i class="mdi mdi-information importantIcon"></i>
              </p>
            </v-row>
            <v-text-field
              single-line
              append-icon="mdi-pencil"
              v-model="myProfile.personalTelephoneNumber"
              :rules="notEmptyRule"
              required
              outline
              class="textField"
              maxlength="15"
            ></v-text-field>
            <v-row>
              <p class="headerText">
                {{ $t("profile_address") }}
                <i class="mdi mdi-information importantIcon"></i>
              </p>
            </v-row>
            <v-text-field
              single-line
              append-icon="mdi-pencil"
              v-model="myProfile.homeAddress"
              :rules="notEmptyRule"
              required
              outline
              class="textField"
              maxlength="50"
            ></v-text-field>
            <v-row class="changePasswordPos">
              <img src="@/assets/lock.svg" v-on:click="changePassword" />
              <p
                class="changePasswordText text-decoration-underline"
                v-on:click="changePassword"
              >{{ $t("change_password") }}</p>
            </v-row>
          </div>
        </v-flex>
      </v-layout>

      <div class="text-center btnPos">
        <v-btn
          class="btnMargin mx-2"
          id="btnCancel"
          v-on:click="cancelClicked"
        >{{ $t("common_cancel") }}</v-btn>
        <v-btn
          class="btnMargin mx-2"
          id="btnEdit"
          v-on:click="handleUpdateProfile"
        >{{ $t("common_update") }}</v-btn>
      </div>
    </v-card>
  </top-view>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import TopView from "../../components/commonui/topView/TopViewFullScreen";
import { DefaultValues } from "@/utilities/CommonUtilities";
import { ListEvents } from "@/utilities/CommonUtilities";
import moment from "moment";

export default {
  components: { TopView },
  data() {
    return {
      birthDateMenu: false,
      birthDate: null,
      imageUrl: "",
      imageFile: "",
      minDate: "1900-07-04",
      maxDate: "3019-08-30",
      myProfile:{},
      notEmptyRule: [v => !!v.trim() || "This field is required"]
    };
  },

  computed: {
    ...mapState(["userInfo"]),
    ...mapGetters(["getUserByID"]),
    userImage() {
      if (this.myProfile && this.myProfile.profiolePhoto != null) {
        return `data:image/png;base64,${this.myProfile.profiolePhoto}`;
      } else {
        return DefaultValues.no_image;
      }
    },
    birthDateValue() {
      return this.formatDate(this.birthDate);
    }
  },
  watch: {
    email() {
      this.apiErrorOccurred = null;
    },
    password() {
      this.apiErrorOccurred = null;
    }
  },
  methods: {
    ...mapMutations({
      updateUserInfo: "updateUserInfo"
    }),
    changePassword() {
      this.$router.push({ name: "changepassword" });
    },
    cancelClicked() {
      this.$router.push("/profile/" + this.myProfile.userID);
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateSendServer(value) {
      if (value) {
        return moment(String(value))
          .add(1, "days")
          .format("yyyy-MM-DD");
      }
    },
    onSelectAvatarClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );
      this.$refs.uploader.click();
    },

    onFileChanged(e) {
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = evt => {
        let img = new Image();
        img.onload = () => {
          var canvas = document.createElement("canvas"),
            max_size = 200,
            width = img.width,
            height = img.height;
          if (width > height) {
            if (width > max_size) {
              height *= max_size / width;
              width = max_size;
            }
          } else {
            if (height > max_size) {
              width *= max_size / height;
              height = max_size;
            }
          }
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(img, 0, 0, width, height);
          this.imageUrl = canvas.toDataURL("image/jpeg");
          this.imageFile = file;
        };
        img.src = evt.target.result;
      };

      reader.onerror = evt => {
        console.error(evt);
      };
    },

    async handleUpdateProfile() {
      if (
        !this.myProfile.name.trim() ||
        !this.myProfile.personalTelephoneNumber.trim() ||
        !this.myProfile.homeAddress.trim()
      )
        return;
      this.notifyBus.$emit(ListEvents.showLoadingIndicator);

      this.myProfile.profiolePhoto = this.imageUrl.split(",")[1];
      this.myProfile.birthDate = this.birthDate;
      let dictParams = {
        user: {
          userID: this.myProfile.userID,
          employeeCode: this.myProfile.employeeCode,
          name: this.myProfile.name,
          department: this.myProfile.department,
          section: this.myProfile.section,
          position: this.myProfile.position,
          emailAddress: this.myProfile.emailAddress,
          telephoneNumber: this.myProfile.telephoneNumber,
          hireDate: this.formatDateSendServer(this.myProfile.hireDate),
          gender: this.myProfile.gender,
          birthDate: this.formatDateSendServer(this.birthDate),
          homeTown: this.myProfile.homeTown,
          homeZipCode: this.myProfile.homeZipCode,
          homeAddress: this.myProfile.homeAddress,
          personalTelephoneNumber: this.myProfile.personalTelephoneNumber,
          profilePhoto: this.myProfile.profiolePhoto
        }
        
      };
      try {
        await this.dataSource.postData(
          this.dataSource.updateProfileURL,
          dictParams
        );
      } catch (ex) {
        return;
      } finally {
        this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
      }
      this.updateUserInfo(this.myProfile);
      this.$router.push({ name: "profile" });
    },
    handleError() {
      this.apiErrorOccurred = this.$i18n.t("common_unknown_error");
    }
  },
  created() {
    Object.assign(this.myProfile, this.userInfo);
    this.birthDate = this.formatDate(this.myProfile.birthDate);
    this.imageUrl = this.userImage;
  },
  inject: ["dataSource", "notifyBus"]
};
</script>
<style scoped>
#cardView {
  width: 100%;
  height: 100%;
}
.profileHeader {
  margin-top: 37px;
  margin-left: 60px;
  margin-right: 20px;
  width: 142px;
  height: 33px;
  text-transform: uppercase;
  color: #333333;
  font: normal normal bold 24px/33px Open Sans;
  white-space: nowrap;
}
.divider {
  margin-top: 63px;
  margin-right: 10px;
}

#listMessage {
  list-style-type: none;
  width: 100%;
  margin: auto;
  color: red;
}
.headerText {
  margin-top: 20px;
  margin-left: 10px;
  width: 0%;
  height: 22px;
  font: normal normal bold 16px/22px Open Sans;
  color: #333333;
  white-space: nowrap;
}
@media only screen and (max-width: 600px) {
  .headerText {
    margin-left: 40px;
  }
}
.importantIcon {
  color: #e561a9;
}
#btnCancel {
  background-color: #e561a9;
  width: 128px;
  height: 35px;
  color: #ffffff;
  font: normal normal bold 14px/8px Open Sans;
  text-align: center;
  text-transform: uppercase;
  opacity: 1;
  border-radius: 1px;
}

#btnEdit {
  background-color: #5e81ed;
  width: 128px;
  height: 35px;
  color: #ffffff;
  font: normal normal bold 14px/8px Open Sans;
  text-align: center;
  text-transform: uppercase;
  opacity: 1;
  border-radius: 1px;
}
.bottom-right {
  position: absolute;
  bottom: -20px;
  right: -20px;
}
.container {
  margin-top: 20px;
  position: relative;
  width: 130px;
  height: 130px;
}
.textField {
  margin-bottom: 20px;
  margin-top: -20px;
  height: 28px;
  margin-left: 30px;
  margin-right: 30px;
}
@media only screen and (min-width: 600px) {
  .textField {
    width: 261px;
    margin-left: 0px;
    margin-right: 0px;
  }
}

.changePasswordPos {
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .changePasswordPos {
    margin-left: 20px;
  }
}
.changePasswordText {
  margin-top: 20px;
  margin-left: 5px;
  width: 122px;
  height: 19px;
  color: #5e81ed;
  font: normal normal bold 14px/22px Open Sans;
  white-space: nowrap;
  cursor:pointer;
}

@media only screen and (min-width: 600px) {
  .avatarPos {
    margin-right: 69px;
  }
}
.btnPos {
  margin-top: 40px;
  margin-bottom: 30px;
}
</style>

